import styled from "@emotion/styled";

import { theme } from "../../Internals/ThemeProvider/CandyTheme/ThemeShorthand";

export const Root = styled.div(props => ({
    border: theme(props).border.dashed,
    padding: theme(props).size([3, 2]),
    borderRadius: theme(props).size(0.5),
}));

export const KeyboardButton = styled.div(props => ({
    display: "inline-block",
    color: theme(props).typography.secondary.color,
    border: `1px solid ${theme(props).typography.secondary.color}`,
    padding: theme(props).size([0, 1]),
    lineHeight: `20px`,
    borderRadius: theme(props).size(0.5),
}));

export const MutedText = styled.span(props => ({
    marginLeft: theme(props).size(2),
    marginRight: theme(props).size(2),
    color: theme(props).typography.secondary.color,
}));
